import { isTransparent, upgradeColor } from '@wix/shoutout-email-model-v3';
export var getUpgradedColor = function (color) {
    return color && isTransparent(color) ? 'transparent' : upgradeColor(color);
};
//# sourceMappingURL=get-upgraded-color.js.map